// extracted by mini-css-extract-plugin
export var filterIncDec = "_cb-0";
export var leftBorder = "_cb-1";
export var rightBorder = "_cb-2";
export var stringInput = "_cb-3";